/* eslint-disable no-use-before-define */
import React from 'react'


const SINGULAR_LABELS = {
    muni_in: 'an in-state tax-exempt municipal bond',
    muni_out: 'an out-of-state municipal bond',
    corp: 'a fully taxable corporate bond',
    tsy: 'a federally taxable treasury bond',
}

const EQUIVALENT_LABELS = {
    muni_in: 'an in-state tax-exempt municipal bond',
    muni_out: 'an out-of-state municipal bond (state/local taxable)',
    corp: 'a fully taxable corporate bond',
    tsy: 'a federally taxable treasury bond',
}

const pct2 = (a) => {
    let x = Number.parseFloat(a)
    return isNaN(x) ? '-' : (x.toFixed(2) + '%')
}

const cap = (s) => s.charAt(0).toUpperCase() + s.slice(1)

export const Summary = ({calculation}) => {
    let { order, values, totalTax, fedTax, stateTax } = calculation || {}
    if (!order || !values) return null

    let productType = order[0]
    let vs = values[3]



    return <div>
        Given your inputs, if you invested in {SINGULAR_LABELS[productType]} with a yield
        of {pct2(vs[order[0]] * 100)}
        {productType==='corp' ? ` which is subject to a combined tax rate of ${pct2(totalTax * 100)}` : ''}
        {productType==='muni_out' ? ` which is subject to a state tax rate of ${pct2(stateTax * 100)}` : ''}
        {productType==='tsy' ? ` which is subject to a federal tax rate of ${pct2(fedTax * 100)}` : ''}
        ,
        this would be equivalent to investing in:
        <li>{cap(EQUIVALENT_LABELS[order[1]])} with a yield of {pct2(vs[order[1]] * 100)}.</li>
        <li>{cap(EQUIVALENT_LABELS[order[2]])} with a yield of {pct2(vs[order[2]] * 100)}.</li>
        <li>{cap(EQUIVALENT_LABELS[order[3]])} with a yield of {pct2(vs[order[3]] * 100)}.</li>
    </div>

}


const PLURAL_LABELS = {
    muni_in: 'in-state municipal bonds',
    muni_out: 'out-of-state municipal bonds',
    corp: 'corporate bonds',
    tsy: 'treasury bonds',
}

export const SearchSummary = ({calculation, searchFor}) => {

    if (!searchFor) return null

    let values = calculation.values
    let minYield = values[6][searchFor]
    let maxYield = values[0][searchFor]

    return <div className="text-italic text-small">
        This search will open a new window and display {PLURAL_LABELS[searchFor]} with a comparable yield range
        between {pct2(minYield * 100)} - {pct2(maxYield * 100)}.
    </div>
}